export const SET_TABLELISTDATA = "SET_TABLELISTDATA";
export const SET_TABLEACTIONDETAILS = "SET_TABLEACTIONDETAILS";
export const SET_TABLESORTINGDATA = "SET_TABLESORTINGDATA";
export const SET_TABLESEARCHDATA = "SET_TABLESEARCHDATA";
